export const TERM_CONDITION = "TERM_CONDITION";
export const TERM_CONDITION_SUCCESS = "TERM_CONDITION_SUCCESS";
export const TERM_CONDITION_FAIL = "TERM_CONDITION_FAIL";